import {Component} from '@angular/core';
import {findMostSpecificImage} from "@ionic/cli-plugin-cordova/dist/lib/resources";
import {version} from "./version"

export let API_BASE_URL = "https://rtapica.jazzba.io/api/v2";	// Dev server
export let nodeSevice = "https://dtapica.jazzba.io/api/v1/";	// Dev server


export let IMAGES_BASE_URL = {imageBaseUrl : "https://anydatapoint.net/"};

// let version = "v2.5.119.106 (stage)";
//let version = "v2.5.140.170";
let Stockversion = "v2.5.127.127.72";


export let AppConfig = {



  /********** *******************************************************************
   *                                                                            *
   *    Set Following Variable for the LOCAL, EV and COMMERCIAL environment    *
   *                                                                            *
   * ****************************************************************************/

  ENVIRONMENT:"DEV", //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']

  /*URL Set For Local Environment*/
  LOCAL_DTAPI_PK:"localhost:8081/api/v1",
  LOCAL_RTAPI_PK:"localhost:8081/api/v2",

  LOCAL_DTAPI_NA:"localhost:8081/api/v1",
  LOCAL_RTAPI_NA:"localhost:8081/api/v2",

  // LOCAL_RA_SERVICE:"http://localhost:8080/api/v1",
  LOCAL_RA_SERVICE:"http://localhost:8080",


  /*URL Set For DEV Environment*/
  DEV_DTAPI_PK:"https://dtapipk.jazzba.io/api/v1",
  DEV_RTAPI_PK:"https://rtapipk.jazzba.io/api/v2",

  DEV_DTAPI_NA:"https://dtapica.jazzba.io/api/v1",
  DEV_RTAPI_NA:"https://rtapica.jazzba.io/api/v2",

  DEV_RA_SERVICE:"https://raservice.jazzba.io",

  DEV_ApiURL_billing: "https://adppayca.jazzba.io/api/v1",

  DEV_Jazzba_Manage: "https://manageca.jazzba.io",


  /*URL Set For COMMERCIAL Environment*/
  COMMERCIAL_DTAPI_PK:"https://dtapica.jazzba.io/api/v1",
  COMMERCIAL_RTAPI_PK:"https://rtapica.jazzba.io/api/v2",

  COMMERCIAL_DTAPI_NA:"https://dtapica.jazzba.io/api/v1",
  COMMERCIAL_RTAPI_NA:"https://rtapica.jazzba.io/api/v2",

  COMMERCIAL_RA_SERVICE:"https://raservice.jazzba.io",

  COMMERCIAL_ApiURL_billing: "https://adppayca.jazzba.io/api/v1",

  COMMERCIAL_Jazzba_Manage: "https://manageca.jazzba.io"

};

export let Constants :any = {
country:"CA",
  version: version,	
  defaultViewType : "list",
   appVersion:"IntelliRep "+version ,
   stockVersion:"IntelliStock" + Stockversion,
   webstoreVersion:"IntelliCommerce "+version ,
   intelliStockVersion: "IntelliStock " + Stockversion,
	 coreVersion:"IntelliCommerce v2.5.01 beta" ,
	 CopyRight:"Copyright \u00A9 2018-2022 JAZZBA." ,
	 sentryToken:"679f61fc8565454eb926396c680b96fe",
	 allowRightsMsgLogin:true,
	 isDebugmode: true,
	 iCommSentryToken:"https://2a6b713e71514f349362004724942285@sentry.io/857435",
	 iRepSentryToken:"https://82521ff9c7484f42b571d755487846a6@sentry.io/857815",
	 // True for webstore and false for App
   isWebstore: false, // Also add custId as rtApiURL parameter and place images in cust-{{customerID}} folder
   IntelliStockRunningIn: "NA", // NA, BROWSER, APP
   IntelliRepRunningIn: "NA", // NA, BROWSER, APP
	 imageCacheSize: 1024, // MB
	 isImageCacheExpiry: true, // allow to expire cache
	 imageCacheExpirytime: 90,	// Days
	 imagesPreloadBuffer: 100,
	 itemRefreshed:false, // for one time event
   fetchCount: 24, // Items fetch count for Offline mode fetch
   Monthly_License_alias:"ims",
   EDI_Integrations_License_alias:"integrations-edi",
  sessionKey: null

	};

export let CollectionAndClasses:any = {collection:[0],subCollection:[0],categories:[0],tags:[0]};

export let ApplicationVariables = { isOffline:false , connectionType:"wifi"};

export let LicenseName = ["LiveRead", "anyOtherName", "InstantRead"];

export function isIntelliStock(){
  if(Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP")
  {
    return true;
  }
  else{
    return false;
  }
}

export let customFields = {
  "orderId": "",

  // this is basic structure that is going the data. If order does not has the custom field in db from adpcustomer table

   params : [
   {"paramId": 1,"label": "Transaction Id","value": eval("this.shipto"), "type" : "linked"},
   {"paramId": 2,"label": "Shipment Id","value": "this.shipto", "type" : "linked"},
   {"paramId": 3,"label": "Warehouse Name","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 4,"label": "Warehouse Code","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 5,"label": "Ship To Name","value": "this.shipto", "type" : "linked"},
   {"paramId": 6,"label": "Ship From Name","value": "this.shipto", "type" : "linked"},
   {"paramId": 7,"label": "Ship From Code","value": "this.shipto", "type" : "linked"},
   {"paramId": 8,"label": "Ship Date","value": "this.shipto", "type" : "Empty"},
   {"paramId": 9,"label": "SCAC","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 10,"label": "Routing","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 11,"label": "Bill Of Lading #","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 12,"label": "Trailer #","value": "this.shipto", "type" : "Empty"},
   {"paramId": 13,"label": "# Of Total Rolls Shipped","value": "this.shipto", "type" : "linked"},
   {"paramId": 14,"label": "# Of Total Packages","value": "this.shipto", "type" : "Empty"},
   {"paramId": 15,"label": "Gross Weight","value": "this.shipto", "type" : "linked"},
   {"paramId": 16,"label": "Gross Weight UOM","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 17,"label": "Order Gross Weight","value": "this.shipto", "type" : "Empty"},
   {"paramId": 18,"label": "Order Gross Weight UOM","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 19,"label": "Mill Order #","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 20,"label": "Grade Code","value": "this.shipto", "type" : "Empty"},
   {"paramId": 21,"label": "Grade Name","value": "this.shipto", "type" : "Empty"},
   {"paramId": 22,"label": "# Of Roll in Packages","value": "this.shipto", "type" : "Empty"},
   {"paramId": 23,"label": "Width","value": "this.shipto", "type" : "Empty"},
   {"paramId": 24,"label": "Width UOM","value": "this.shipto", "type" : "Hard coded"},
   {"paramId": 25,"label": "Line #","value": "this.shipto", "type" : "linked"},
   {"paramId": 26,"label": "Roll #","value": "this.shipto", "type" : "linked"},
   {"paramId": 27,"label": "Item Gross Weight","value": "this.shipto", "type" : "linked"},
   {"paramId": 28,"label": "Item Gross Weight UOM","value": "this.shipto", "type" : "Hard coded"},
   ],

   //section is telling the grouping of the fields inside the custom fields form

  sections: [
    {
      "name" : "pickpackField", "lable" : "PICK Pack Fields", sectionParams :[{"paramId" : "1", "sequence" : 1}]
    },

    {
      "name" : "ASNForm", "lable" : "ASN Form", sectionParams :[{"paramId" : "1", "sequence" : 2}]
    },

    {
      "name" : "BOLForm", "lable" : "BOL Form", sectionParams :[{"paramId" : "1", "sequence" : 3}]
    },

    {
      "name" : "commonParam", "lable" : "Common Param", sectionParams :[{"paramId" : "1", "sequence" : 4}]
    }
   ]
}



// WEBPACK FOOTER //
// ./src/providers/config.ts